import "core-js/modules/es6.regexp.search";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { previewDataInterface } from '@/api/systemData/dataInterface'
import request from "@/utils/request";
export default {
  name: "suppliers",
  props: {
    value: {
      default: ""
    },
    interfaceId: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    // 请求接口方式默认POST
    strmethod: {
      type: String,
      default: "POST"
    },
    propsValue: {
      type: String,
      default: ""
    },
    columnOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    appendtobody: {
      type: Boolean,
      default: true
    },
    // 搜索条件
    SearchKey: {
      type: String,
      default: ""
    },
    notname: {
      type: Boolean,
      default: false
    },
    //公司名称
    corporatename: {
      type: String,
      default: ""
    },
    //判断是否要传公司名称
    corporatenamesta: {
      type: Boolean,
      default: false
    },
    disableds: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "value",
    event: "input"
  },
  data: function data() {
    return {
      like1: "",
      like2: "",
      arr: "",
      mea: "",
      paces: "",
      sizename: "",
      checkedTxtt: "",
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      total: 0,
      list: [],
      filteredList: [],
      innerValue: "",
      keyword: "",
      keyname: "",
      checked: "",
      checkedTxt: "",
      listLoading: false,
      visible: false,
      refreshDataList: []
    };
  },
  watch: {
    value: function value(val) {
      this.setDefault();
    }
  },
  computed: {
    propsLabel: function propsLabel() {
      return this.columnOptions[0].value;
    }
  },
  created: function created() {
    this.getData();
    // this.initData()
  },
  methods: {
    values: function values(val) {
      if (this.innerValue == "") {
        this.checked = this.innerValue;
        this.$emit("input", this.checked);
        this.$emit("change", this.checked);
      }
    },
    getDatalive: function getDatalive() {
      console.log("111");
      this.innerValue = "";
    },
    getData: function getData() {
      var _this = this;
      if (!this.interfaceId) return;
      this.listLoading = true;
      var _query = _objectSpread({}, this.listQuery);
      var query = {};
      for (var key in _query) {
        if (Array.isArray(_query[key])) {
          query[key] = _query[key].join();
        } else {
          query[key] = _query[key];
        }
      }
      var arrlist = "";
      console.log(this.corporatename, "this.corporatename");
      if (this.keyword == "" && this.corporatename == "") {
        arrlist = "";
      } else if (this.keyword == "" && this.corporatename != "") {
        arrlist = "AND COMPANY_NAME='".concat(this.corporatename, "'");
      } else if (this.keyword != "" && this.corporatename == "") {
        arrlist = "AND F_CODE LIKE'%".concat(this.keyword, "%'OR F_NAME LIKE'%").concat(this.keyword, "%'OR MNEMONICS LIKE'%").concat(this.keyword, "%'");
      } else {
        arrlist = "AND (F_CODE LIKE'%".concat(this.keyword, "%'OR F_NAME LIKE'%").concat(this.keyword, "%'OR MNEMONICS LIKE'%").concat(this.keyword, "%')AND COMPANY_NAME='").concat(this.corporatename, "'");
      }
      request({
        url: this.interfaceId + "/" + this.listQuery.currentPage + "/" + this.listQuery.pageSize,
        method: this.strmethod,
        data: {
          // "WhereSql": "AND F_CODE=" + "'" + this.keyword + "'" + "AND ITEM_NAME=" + "'" + this.keyname
          WhereSql: arrlist
          // this.arr +
          // this.like1 +
          // this.arrr +
          // this.acs +
          // this.like2 +
          // this.acss
          // text:
        }
      }).then(function (res) {
        _this.filteredList = res.data.list;
        _this.listLoading = false;
        _this.total = res.data.pagination.total;
        _this.setDefault();
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    search: function search() {
      this.getData();
    },
    reset: function reset() {
      this.keyword = "";
      this.keyname = "";
      this.filteredList = this.list;
      this.search();
    },
    refresh: function refresh() {
      this.keyword = "";
      this.getData();
    },
    openDialog: function openDialog() {
      if (this.disableds == true && this.corporatename == "" && this.corporatenamesta == false) {
        this.$message({
          message: "请先输入公司名称",
          type: "warning",
          duration: 1000
        });
      } else if (this.disabled == true && this.corporatenamesta == true) {} else {
        this.checked = this.value;
        this.visible = true;
        if (!this.list.length) {
          this.keyword = this.innerValue;
          this.search();
        } else {
          this.filteredList = this.list;
        }
      }

      // return;
      // this.keyword = "";

      // this.getData();
    },
    clear: function clear() {
      this.checked = "";
      this.innerValue = "";
      this.$emit("input", this.checked);
      this.$emit("change", this.checked);
      this.$emit("refreshDataList", []);
    },
    select: function select() {
      if (!this.checked) return;
      this.innerValue = this.checkedTxt;
      this.$emit("input", this.checked);
      this.$emit("change", this.checked);
      this.$emit("getName", this.checkedTxtt);
      // this.$emit("refreshDataList", this.refreshDataList);
      this.visible = false;
    },
    rowClick: function rowClick(row) {
      // this.refreshDataList = row;
      this.checked = row[this.propsValue];
      this.checkedTxt = row[this.propsLabel];
      this.checkedTxtt = row.CUSTOMERNAME;
      // console.log(row.CUSTOMERNAME)
    },
    setDefault: function setDefault() {
      var _this2 = this;
      console.log(this.value, "value2");
      if (!this.value) {
        this.$emit("refreshDataList", []);
        return this.innerValue = "";
      }
      request({
        url: this.interfaceId + "/" + this.listQuery.currentPage + "/" + this.listQuery.pageSize,
        method: this.strmethod,
        data: {
          WhereSql: "AND F_KEY LIKE " + "'" + this.value + "'"
        }
      }).then(function (res) {
        console.log(res);
        if (res.data.list != "") {
          if (_this2.notname != true) {
            _this2.innerValue = res.data.list[0].F_NAME;
          }
          for (var i = 0; i < res.data.list.length; i++) {
            if (res.data.list[i].F_KEY == _this2.value) {
              if (_this2.notname != true) {
                _this2.innerValue = res.data.list[i].F_NAME;
              } else {
                _this2.innerValue = res.data.list[i].F_CODE;
              }
              _this2.$emit("refreshDataList", res.data.list[i]);
              break;
            }
          }
          console.log(_this2.innerValue, "this.innerValue");
          _this2.$emit("refreshDataList", res.data.list[0]);
        }
      });
      // for (let i = 0; i < this.list.length; i++) {
      //   if (this.list[i][this.propsValue] === this.value) {
      //     this.innerValue = this.list[i][this.propsLabel];
      //     this.$emit("refreshDataList", this.list[i]);
      //     break;
      //   }
      // }
    }
  }
};